// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.overlay{
        z-index:9;
}
.wizard-card-footer {
        border-top: 1px solid rgba(10,191,83,0.1);
        background-color: rgba(10,191,83,0.1);
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0.8125rem !important;
        border-bottom-left-radius: 0.8125rem !important;
}
.vue-form-wizard .wizard-card-footer {
        padding: 0;
}
.vue-form-wizard {
        padding-bottom: 0px !important;
}
.wizard-tab-content {
        padding-top: 0 !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
        padding-bottom: 1px !important;
}
.card {
        position: relative;
}
.overlay {
        background-color:white;
        position: absolute;
        width: 100%;
        height:100%;
        top: 0;
        left: 0;
        opacity: 0.9;
}
.card-transition:hover {
        background-color: rgba(10,191,83,.075) !important;
        border-color: forestgreen;
}
.card-title{
        margin-bottom: 0 !important;
}
.wizard-nav.wizard-nav-pills {
        border-bottom: 1px solid lightgray !important;
        padding-bottom: 15px;
}
.stepTitle {
        color: darkgray !important;
}
.stepTitle.active {
        color: black !important;
}
.wizard-btn{
        color: black !important;
}
    /* Style the .contact-content div */
.contact-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
}
.contact-content::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7);
}
    
        /* Style the content inside .contact-content */
.contact-content .row {
            color: #fff;
}

        /* Style the content divs inside .contact-content */
.contact-content .col-1 {
            /* Add your styling for the icon column */
}
.contact-content .col-11 {
            /* Add your styling for the address column */
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
